import { Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const quickLinks = [
    { name: 'Home', id: 'home' },
    { name: 'Locations', id: 'locations' },
    { name: 'Community', id: 'community' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_84a4a60d-7b7a-4891-9b3e-916a052c67d8/artifacts/mqmr6ogp_CoPlay%20Logo%20%28Blue%29%4033.33x-8.png" 
                alt="CoPlay Logo" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-slate-400 mb-6">
              India's premier community-driven sports facility network. Play, connect, and compete with us.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/coplayofficial"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/coplaycommunity"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                data-testid="social-linkedin"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6" data-testid="quick-links-title">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-400 hover:text-blue-400 transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div></div>

          <div>
            <h3 className="text-lg font-bold mb-6" data-testid="contact-title">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-slate-400" data-testid="footer-email">
                <Mail className="w-5 h-5 text-blue-500" />
                <a href="mailto:contact@hudle.in" className="hover:text-blue-400 transition-colors">
                  contact@hudle.in
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400" data-testid="footer-phone">
                <Phone className="w-5 h-5 text-blue-500" />
                <a href="tel:01141186664" className="hover:text-blue-400 transition-colors">
                  01141186664
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-slate-400">
          <p data-testid="copyright">&copy; {new Date().getFullYear()} Hsquare Sports Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
